export default "__VITE_ASSET__8e43c0c1__"